import React from "react";
import styled from "styled-components";

// Context
import { useFormSelectDialog } from "core/FormSelectDialog/context/useFormSelectDialog";

// components
import CaretDown, {
    Image as CaretDownIcon
} from "core/ReusableIcons/CaretDown";

// styles
import { convertPxToRem } from "frontend/components/helpers";
export const IconCaretStyled = styled.div`
    flex: 0 0 ${convertPxToRem(16)};
    display: flex;
    justify-content: center;
    align-items: center;

    ${CaretDownIcon} {
        width: ${convertPxToRem(16)};
        height: ${convertPxToRem(16)};

        position: relative;
        top: ${convertPxToRem(1)};
        transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : "none")};
    }
`;

// component
export const IconCaret = () => {
    const { isOpen, dialogPlacement } = useFormSelectDialog();
    return (
        <IconCaretStyled $isOpen={isOpen} $dialogPlacement={dialogPlacement}>
            <CaretDown />
        </IconCaretStyled>
    );
};

export default IconCaret;
